import React, { use, useEffect, useState, lazy, Suspense } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import Issuessummary from "./Issuesummary";
import {
  getIssueDetail,
  getIssuePartDetails,
  getVehicleByLicensePlate,
  getVendorsList,
  getIssueGenericTransaction,
} from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import Partdetails from "./PartDetails";
import Others from "./Others";
import Issueimages from "./Issueimages";
import Vendordetails from "./Vendordetails";
import Addissuetransaction from "./Addissuetransaction";
import Costconfiguration from "./Costconfiguration";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import toast from "react-hot-toast";
import Commonmodal from "../../common/Commonmodal";
import Issuecomments from "./Issuecomments";

const Viewissuesdetail = ({
  setSearchvalues,
  selectedRow,
  setOpenTab,
  setSelectSearchValues,
  getAllIssues,
  setPaginationModel,
}) => {  
  const queryIssueid = new URLSearchParams(window.location.search).get(
    "issueId"
  );
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issueStatus;
  delete issueStatus?.inverted;
  const vendorTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.vendorTypes;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [firstLoading, setFirstLoading] = useState(false);
  const [issueDetails, setIssueDetails] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [VehicleDetail, setVehicleDetail] = useState(null);
  const [issuePartDetails, setIssuePartDetails] = useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [issueGenericTransaction, setIssueGenericTransaction] = useState(null);
  const [changeIssueStatus, setChangeIssueStatus] = useState(null);
  const [bookingDetail, setBookingDetail] = useState(null);
  const [openImageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClose = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleImageOpen = (url) => {
    setSelectedImage(url);
    setImageModal(true);
  };

  const getIssueDetailAPI = async (value) => {
    setFirstLoading(true);
    const apiDetails = await getIssueDetail(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setFirstLoading(false);
    setIssueDetails(data?.entityValue);
    await getVehicleDetailAPI(data?.entityValue?.vehicleRegistration);
    if (data?.entityValue?.bookingCode) {
      await getVehicleIssueBookingAPI(data?.entityValue?.bookingCode);
    }
  };

  const getVehicleIssueBookingAPI = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings?bookingCode=${bookingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBookingDetail(data?.entities?.rows);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const getVehicleDetailAPI = async (vehicleRegistration) => {
    setFirstLoading(true);
    const apiDetails = await getVehicleByLicensePlate(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setFirstLoading(false);
    setVehicleDetail(data?.entities?.rows[0]);
  };

  const getIssuePartDetailsAPI = async (vehicleRegistration) => {
    setFirstLoading(true);
    const apiDetails = await getIssuePartDetails(vehicleRegistration);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setFirstLoading(false);
    setIssuePartDetails(data?.entities?.rows);
  };

  const getVendorsListAPI = async () => {
    const apiDetails = await getVendorsList();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendorList(data?.entities?.rows);
  };

  const getIssueGenericTransactionAPI = async (issueId) => {
    setFirstLoading(true);
    const apiDetails = await getIssueGenericTransaction(issueId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setFirstLoading(false);
      setIssueGenericTransaction(data?.entities?.rows);
    }
  };

  useEffect(() => {
    if (selectedRow?.id || queryIssueid) {
      getIssueDetailAPI(selectedRow?.id || queryIssueid);
      getIssuePartDetailsAPI(selectedRow?.id || queryIssueid);
      getIssueGenericTransactionAPI(selectedRow?.id || queryIssueid);
    }
  }, [selectedRow, queryIssueid]);

  const getTabs = () => {
    const tabs = [
      { id: "addpartdetails", label: "Add Part Details" },
      { id: "costconfiguration", label: "Cost Configuration" },
      { id: "alltransactions", label: "All Transactions" },
      { id: "vendordetails", label: "Vendor Details" },
      { id: "allimages", label: "All Images" },
      { id: "issuecomments", label: "Issue Comments" },
      { id: "others", label: "Others" },
    ];

    return tabs;
  };

  useEffect(() => {
    const tabs = getTabs();
    if (tabs.length > 0) {
      setActiveTab(tabs[0].id);
    }
  }, [issueDetails]);

  const changeIssueStatusAPI = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicleissues`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: issueDetails?.id,
          status: changeIssueStatus,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Status Changed successfully");
        await getIssueDetailAPI(selectedRow?.id || queryIssueid);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  useEffect(() => {
    if (changeIssueStatus) {
      changeIssueStatusAPI();
    }
  }, [changeIssueStatus]);

  const handleReset = async () => {
    setOpenTab(false);
    // setSearchvalues("")
    // setSelectSearchValues(null)
    // setPaginationModel()
    // await getAllIssues();

    window.history.replaceState({}, "", window.location.pathname);
  };

  return (
    <>
      {openImageModal && (
        <>
          <Commonmodal
            open={handleImageOpen}
            onClose={handleImageClose}
            url={selectedImage}
          />
        </>
      )}

      <div id="bookingdetailstabid">
        <div className="max-w-screen-2xl mx-auto py-4 h-screen overflow-y-scroll scrollbar-hide text-gray-900">
          {/* Header */}
          <div className="border border-black bg-white text-black p-6 rounded-t-3xl flex flex-col md:flex-row justify-between items-start md:items-center gap-6 shadow-xl">
            {/* Left Section: Issue Info */}
            <div className="flex flex-col gap-1">
              <h1 className="text-3xl font-extrabold tracking-tight">
                Issue ID:{" "}
                <span className="text-indigo-800">{issueDetails?.code}</span>
              </h1>
              <p className="text-sm opacity-80">
                Reported on: {formatDateAndTime(issueDetails?.reportedOn)}
              </p>
            </div>

            {/* Right Section: Actions */}
            <div className="flex gap-4 flex-wrap md:flex-nowrap items-center">
              {/* MUI Select */}
              <FormControl
                sx={{
                  width: 220,
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    color: "#000",
                    "& fieldset": {
                      borderColor: "#050505ff",
                    },
                    "&:hover fieldset": {
                      borderColor: "#111111ff",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#0a0a0aff",
                    },
                  },
                }}
                size="small"
              >
                <InputLabel
                  sx={{ color: "#555", "&.Mui-focused": { color: "#555" } }}
                >
                  Change Status
                </InputLabel>
                <Select
                  value={changeIssueStatus || ""}
                  onChange={(e) => setChangeIssueStatus(e.target.value)}
                  label="Change Status"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        maxHeight: 260,
                        borderRadius: "10px",
                        boxShadow: "0 10px 20px rgba(0,0,0,0.12)",
                      },
                    },
                  }}
                >
                  {Object.entries(issueStatus).map(([key, value]) => (
                    <MenuItem
                      key={key}
                      value={key}
                      sx={{
                        "&:hover": { backgroundColor: "#f0f0f0" },
                      }}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Go Back Button */}
              <button
                onClick={handleReset}
                className="relative group border-2 border-black bg-white text-black font-semibold rounded-2xl h-14 w-56 overflow-hidden shadow-lg flex items-center justify-center hover:shadow-xl transition-all duration-300"
              >
                <div className="absolute left-0 top-1/2 -translate-y-1/2 h-full w-0 bg-green-500 group-hover:w-full transition-all duration-500 z-0 rounded-2xl" />
                <span className="relative z-10 flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                    fill="currentColor"
                  >
                    <path d="M10 19l-7-7 7-7v14zM12 5h8v14h-8V5z" />
                  </svg>
                  Go Back
                </span>
              </button>
            </div>
          </div>

          {firstLoading ? (
            <>
              <div className="flex flex-col items-center h-40 justify-center">
                <BlinkBlur color={["#327fcd"]} />
              </div>
            </>
          ) : (
            <>
              <Issuessummary
                issueDetails={issueDetails}
                selectedRow={selectedRow}
                issuePartDetails={issuePartDetails}
                getIssuePartDetailsAPI={getIssuePartDetailsAPI}
                VehicleDetail={VehicleDetail}
                bookingDetail={bookingDetail}
                handleImageOpen={handleImageOpen}
                issueGenericTransaction={issueGenericTransaction}
              />

              <div className="block md:hidden mt-4">
                <select
                  value={activeTab}
                  onChange={(e) => setActiveTab(e.target.value)}
                  className="border border-gray-300 rounded-md p-2 w-full"
                >
                  {getTabs().map((tab) => (
                    <option key={tab.id} value={tab.id}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex p-4">
                <div className="w-48 bg-gray-100 border-r border-gray-300 hidden md:block">
                  {getTabs().map((tab) => (
                    <div
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`cursor-pointer px-4 py-3 font-semibold border-l-4 ${
                        activeTab === tab.id
                          ? "bg-blue-100 border-blue-600 text-blue-600"
                          : "border-transparent text-gray-600 hover:bg-blue-50"
                      }`}
                    >
                      {tab.label}
                    </div>
                  ))}
                </div>

                {/* Tab Content */}
                <div className="flex-1 bg-white p-4 shadow-xl rounded-r-2xl">
                  {activeTab === "addpartdetails" && (
                    <div>
                      <Partdetails
                        issueDetails={issueDetails}
                        setVendorList={setVendorList}
                        vendorList={vendorList}
                        getVendorsListAPI={getVendorsListAPI}
                        getIssuePartDetailsAPI={getIssuePartDetailsAPI}
                      />
                    </div>
                  )}
                  {activeTab === "costconfiguration" && (
                    <div>
                      <Costconfiguration
                        selectedRow={selectedRow}
                        getIssueDetailAPI={getIssueDetailAPI}
                        issueDetails={issueDetails}
                      />
                    </div>
                  )}

                  {activeTab === "issuecomments" && (
                    <div>
                      <Issuecomments
                        selectedRow={selectedRow}
                      />
                    </div>
                  )}

                  {activeTab === "alltransactions" && (
                    <div>
                      <Addissuetransaction
                        getIssueGenericTransactionAPI={
                          getIssueGenericTransactionAPI
                        }
                        selectedRow={selectedRow}
                        issueGenericTransaction={issueGenericTransaction}
                        handleImageOpen={handleImageOpen}
                        getIssueDetailAPI={getIssueDetailAPI}
                        issueDetails={issueDetails}
                      />
                    </div>
                  )}
                  {activeTab === "vendordetails" && (
                    <div>
                      <Vendordetails
                        vendorList={vendorList.filter(
                          (item) =>
                            String(item?.vendorType) ===
                            vendorTypes?.inverted?.service
                        )}
                        selectedRow={selectedRow}
                        issueDetails={issueDetails}
                      />
                    </div>
                  )}
                  {activeTab === "allimages" && (
                    <div>
                      <Issueimages
                        selectedRow={selectedRow}
                        VehicleDetail={VehicleDetail}
                        handleImageOpen={handleImageOpen}
                        issueDetails={issueDetails}
                      />
                    </div>
                  )}
                  {activeTab === "others" && (
                    <div>
                      <Others getVendorsListAPI={getVendorsListAPI} />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Viewissuesdetail;
